// Interface
export interface IdsInputInterface {
  input?: any;
  value?: any;
  checked?: any;
  fieldContainer?: HTMLElement | SVGElement | null;
  labelEl?: HTMLLabelElement | null;
  suppressValidation?: boolean;
}

// Types
const TYPES = {
  default: 'text',
  text: 'text',
  password: 'password',
  number: 'number',
  phone: 'tel',
  email: 'email',
  color: 'color'
} as const;

type TypeKeys = keyof typeof TYPES;

type TypeValues = typeof TYPES[TypeKeys];

// Setting defaults sizes
const SIZES = {
  default: 'md',
  xs: 'xs',
  sm: 'sm',
  mm: 'mm',
  md: 'md',
  lg: 'lg',
  full: 'full'
} as const;

type SizeKeys = keyof typeof SIZES;

type SizeValues = typeof SIZES[SizeKeys];

// Setting defaults text-align
const TEXT_ALIGN = {
  default: 'start',
  start: 'start',
  center: 'center',
  end: 'end'
};

const LABEL_WRAPS = ['ellipsis', 'wrap', 'ellipsis-no-stretch', 'wrap-no-stretch'];

/** Map of margin-block-end token shorthand keys to CSS variable expressions */
const MARGIN_BLOCK_END_SIZES = {
  none: 'var(--ids-space-none)',
  '4xs': 'var(--ids-space-4xs)',
  '3xs': 'var(--ids-space-3xs)',
  '2xs': 'var(--ids-space-2xs)',
  xs: 'var(--ids-space-xs)',
  sm: 'var(--ids-space-sm)',
  md: 'var(--ids-space-md)',
  lg: 'var(--ids-space-lg)',
  xl: 'var(--ids-space-xl)',
  '2xl': 'var(--ids-space-2xl)',
  '3xl': 'var(--ids-space-3xl)',
  '4xl': 'var(--ids-space-4xl)',
} as const;

type MarginBlockEndKey = keyof typeof MARGIN_BLOCK_END_SIZES;

/** Valid values for the HTML inputmode attribute */
const INPUTMODE_VALUES = ['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url'] as const;

const instanceCounter = 0;

export {
  LABEL_WRAPS,
  TYPES,
  TypeKeys,
  TypeValues,
  SIZES,
  SizeKeys,
  SizeValues,
  TEXT_ALIGN,
  MARGIN_BLOCK_END_SIZES,
  MarginBlockEndKey,
  INPUTMODE_VALUES,
  instanceCounter
};
